//Manage Users - For Super User (Edit and Delete Option)

import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Paper,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  IconButton,
  Typography,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Radio, RadioGroup,
  Snackbar, Alert
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
const API_URL = "https://script.google.com/macros/s/AKfycbwfbdmEPa2r0OJg5QINEEeFlut8zqEzWi6aTLOwZ_FEiLipsf6lVjTd-i0OZkrxwPgr3g/exec";



const DataTable = () => {
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({
    First_Name: "",
    Mobile_Number: "",
    Member_ID: "",
    Payment: "",
    ID_Card: "",
  });
  const [loading, setLoading] = useState(true);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editedUser, setEditedUser] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);


  const [formData2, setFormData2] = useState({
      firstName: "",
      lastName: "",
      mobile: "",
      dob: "",
      city: "",
      district: "",
      state: "",
      pincode: "",
      identityProofType: "",
      identityProofNumber: "",
      panCard: "",
      panCardNumber: "",
      email: "",
      occupation: "",
      address: "",
      familyDetails: "",
      maritalStatus: "",
      star: "",
      userType: "",
      raasi: "",
      kootram: "",
      kuladeivam: "",
      paymentStatus: "",
    });

     useEffect(() => {

      
        setFormData2({
          firstName: editedUser ? editedUser.First_Name : "",
          lastName: editedUser ? editedUser.Last_Name: "",
          mobile: editedUser ? editedUser.Mobile_Number: "",
          dob: editedUser ? editedUser.DOB: "",
          city: editedUser ? editedUser.City: "",
          district: editedUser ? editedUser.District: "",
          state: editedUser ? editedUser.State: "",
          pincode: editedUser ? editedUser.Pincode: "",
          identityProofType: editedUser ? editedUser.identityProofType: "",
          identityProofNumber: editedUser ? editedUser.identityProofNumber: "",
          panCard: editedUser ? editedUser.panCard: "",
          panCardNumber: editedUser ? editedUser.panCardNumber: "",
          email: editedUser ? editedUser.Email: "",
          occupation: editedUser ? editedUser.Occupation: "",
          address: editedUser ? editedUser.Address: "",
          familyDetails: editedUser ? editedUser.Family_Details: "",
          maritalStatus: editedUser ? editedUser.Marital_Status: "",
          star: editedUser ? editedUser.Star: "",
          userType: editedUser ? editedUser.User_Type: "",
          raasi: editedUser ? editedUser.Raasi: "",
          kootram: editedUser ? editedUser.Kootram: "",
          kuladeivam: editedUser ? editedUser.Kuladeivam: "",
          paymentStatus: editedUser ? editedUser.Payment_Status: "",

        });
      }, [editedUser]);

    const handleSubmit = async () => {
      const formattedDob = new Date(editedUser.DOB).toLocaleDateString("en-CA");

      const requestBody = {
        method: "put",
        ...editedUser,
        Payment_Status: editedUser.Payment_Status,
        body: JSON.stringify(editedUser),
        ...formData2,
        dob: formattedDob,
      };
      

      console.log("Sending Data:", requestBody);
      try {
        const response = await fetch(
          "https://script.google.com/macros/s/AKfycbwfbdmEPa2r0OJg5QINEEeFlut8zqEzWi6aTLOwZ_FEiLipsf6lVjTd-i0OZkrxwPgr3g/exec",
          {
            method: "POST",
            mode: "no-cors",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          }
        );
  
        console.log("Data sent successfully:", requestBody);
        setOpenEditModal(false);
        setSelectedUser(null);
        setEditedUser(null);

        // Show success Snackbar
        setSnackbarMessage("Member updated successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);

     // Close dialog after successful submission
      } catch (error) {
        console.error("Error sending data:", error);
        alert("Failed to send data");

        // Show error Snackbar
        setSnackbarMessage("Failed to update member!");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    };

  const fetchData = async () => {
    const mobile = localStorage.getItem("mobile");
    const userType = localStorage.getItem("user_type");

    if (!mobile || !userType) {
      console.error("Mobile number or user type not found in localStorage");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${API_URL}?action=manageuser&mobile=${mobile}&usertype=${userType}`);
      const result = await response.json();
      console.log("API Response:", result);

      if (result.status === "success" && Array.isArray(result.data)) {
        setData(result.data);
      } else {
        console.error("Unexpected API response structure", result);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleCreate = () => {
    navigate("/userprofile");
  };

  const handleEdit = (user) => {
    setSelectedUser(user);
    setEditedUser({ ...user }); // Copy user data to editable state
    setOpenEditModal(true);
    
   
  };

  const handlePaymentStatusChange = (status) => {
    console.log("Payment status changed:", status);
    setEditedUser((prev) => ({ ...prev, Payment_Status: status }));
  
    // Update the data in the table
    setData((prevData) =>
      prevData.map((row) =>
        row.Member_ID === editedUser?.Member_ID // Match by ID
          ? { ...row, Payment: status } // Update the Payment field
          : row
      )
    );
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };


  const handleDelete = async (index) => {
    console.log("Deleting index:", index);

    if (!data[index]) {
        console.error("Invalid index or missing data entry");
        
        return;
    }

    const mobileToDelete = data[index]?.Mobile_Number;
    const userMobile = localStorage.getItem("mobile");

    console.log("Mobile to delete:", mobileToDelete);
    console.log("User Mobile from localStorage:", userMobile);

    if (!mobileToDelete || !userMobile) {
        console.error("Missing mobile number for deletion or user mobile");
        
        return;
    }

    try {
        const response = await fetch("https://script.google.com/macros/s/AKfycbwfbdmEPa2r0OJg5QINEEeFlut8zqEzWi6aTLOwZ_FEiLipsf6lVjTd-i0OZkrxwPgr3g/exec", {
            method: "POST",  
            mode: "no-cors", // Prevents CORS issues
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                method: "delete",
                mobile: userMobile,
                userType: "superuser",
                deleteMobile: mobileToDelete,
            }),
        });




        // ✅ Update UI after successful deletion
        setData((prevData) => prevData.filter((_, i) => i !== index));

    } catch (error) {
        console.error("❌ Failed to delete:", error.message);
    }
    setOpenSnackbar(true);
};

  const handleClose = () => {
    setOpenEditModal(false);
    setSelectedUser(null);
    setEditedUser(null);
  };

  const handleSaveEdit = () => {
    if (!editedUser) return;

    // handleSubmit();
    setData((prevData) =>
      prevData.map((item) => (item.Member_ID === editedUser.Member_ID ? editedUser : item))
    );

  
  };

  const filteredData = data.filter((row) =>
    Object.entries(filters).every(([key, filterValue]) => {
      if (!filterValue) return true; // Skip empty filters
  
      const value = row[key] ? row[key].toString().toLowerCase() : "";
  
      if (key === "Payment" || key === "ID_Card") {
        return value === filterValue.toLowerCase(); // Exact match for Payment Status
      }
  
      return value.includes(filterValue.toLowerCase()); // Partial match for other fields
    })
  );
  

  return (
    <div style={{ padding: 20 }}>
      <Typography variant="h5" align="center" color="error" gutterBottom>
        Manage Users
      </Typography>

      <div style={{ display: "flex", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
        <Button variant="contained" color="success" onClick={handleCreate}>
          Create
        </Button>
        <TextField name="First_Name" label="First Name" variant="outlined" size="small" value={filters.First_Name} onChange={handleFilterChange} />
        <TextField name="Mobile_Number" label="Mobile Number" variant="outlined" size="small" value={filters.Mobile_Number} onChange={handleFilterChange} />
        <TextField name="Member_ID" label="Member ID" variant="outlined" size="small" value={filters.Member_ID} onChange={handleFilterChange} />
        <TextField name="Payment" label="Payment Status" variant="outlined" size="small" value={filters.Payment} onChange={handleFilterChange} />
        <TextField name="ID_Card" label="ID Card Status" variant="outlined" size="small" value={filters.ID_Card} onChange={handleFilterChange} />
      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: "#FFD700" }}>
            <TableRow>
              <TableCell><b>First Name</b></TableCell>
              <TableCell><b>Mobile Number</b></TableCell>
              <TableCell><b>Member ID</b></TableCell>
              <TableCell><b>Payment</b></TableCell>
              <TableCell><b>ID Card</b></TableCell>
              <TableCell><b>Actions</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : filteredData.length > 0 ? (
              filteredData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.First_Name || "N/A"}</TableCell>
                  <TableCell>{row.Mobile_Number || "N/A"}</TableCell>
                  <TableCell>{row.Member_ID || "N/A"}</TableCell>
                  <TableCell>{row.Payment_Status || "Pending"}</TableCell>
                  <TableCell>{row.ID_Card || "Not Issued"}</TableCell>
                  <TableCell>
                    <IconButton color="primary" onClick={() => handleEdit(row)}>
                      <EditIcon />
                    </IconButton>
                    <Snackbar open={snackbarOpen} autoHideDuration={2000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}  >
                    <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
                      {snackbarMessage}
                    </Alert>
                  </Snackbar>

                    
                    
                    <IconButton color="error" onClick={() => handleDelete(index)}>
                      <DeleteIcon />
                    </IconButton>
                    {/* Snackbar for delete success message */}
                    <Snackbar
                        open={openSnackbar}
                        autoHideDuration={4000}
                        onClose={() => setOpenSnackbar(false)}
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}  
                    >
                      <Alert
                          onClose={() => setOpenSnackbar(false)}
                          severity="success" // Green background
                          sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}
                      >
                        Member Deleted successfully!
                    </Alert>
                </Snackbar>

                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No records found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Edit User Popup Modal */}
      <Dialog open={openEditModal} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Edit User Profile</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
            <TextField fullWidth margin="dense" label="First Name" value={editedUser?.First_Name || ""} 
            onChange={(e) => setEditedUser({...editedUser, First_Name: e.target.value})} />
            </Grid>
            <Grid item xs={6}>
            <TextField fullWidth margin="dense" label="Last Name" value={editedUser?.Last_Name || ""} 
            onChange={(e) => setEditedUser({...editedUser, Last_Name: e.target.value})} />
            </Grid>
            <Grid item xs={6}>
            <TextField
              fullWidth
              type="date"
              margin="dense"
              label="Date of Birth"
              value={editedUser?.DOB ? new Date(editedUser.DOB).toISOString().split("T")[0] : ""}
              onChange={(e) => setEditedUser({ ...editedUser, DOB: e.target.value })}
              inputProps={{
                max: new Date().toISOString().split("T")[0] // Ensures max date is today
              }}
            />
          </Grid>

            <Grid item xs={6}>
            <TextField fullWidth type="number" margin="dense" label="Mobile Number" value={editedUser?.Mobile_Number || ""} 
            onChange={(e) => setEditedUser({...editedUser, Mobile_Number: e.target.value})} />
            </Grid>
            <Grid item xs={6}>
            <TextField fullWidth margin="dense" label="City" value={editedUser?.City || ""} 
            onChange={(e) => setEditedUser({...editedUser, City: e.target.value})} />
            </Grid>
            <Grid item xs={6}>
            <FormControl fullWidth margin="dense">
              <InputLabel shrink
              sx={{
                backgroundColor: "#ffffff",
                px: 1,
                transform: "translate(14px, -6px) scale(0.75)",
               }}
              >District</InputLabel>
              <Select
                value={editedUser?.District || ""}
                onChange={(e) => setEditedUser({ ...editedUser, District: e.target.value })}
              >
                <MenuItem value="Ariyalur">Ariyalur</MenuItem>
                <MenuItem value="Chengalpattu">Chengalpattu</MenuItem>
                <MenuItem value="Chennai">Chennai</MenuItem>
                <MenuItem value="Coimbatore">Coimbatore</MenuItem>
                <MenuItem value="Cuddalore">Cuddalore</MenuItem>
                <MenuItem value="Dharmapuri">Dharmapuri</MenuItem>
                <MenuItem value="Dindigul">Dindigul</MenuItem>
                <MenuItem value="Erode">Erode</MenuItem>
                <MenuItem value="Kallakurichi">Kallakurichi</MenuItem>
                <MenuItem value="Kancheepuram">Kancheepuram</MenuItem>
                <MenuItem value="Kanyakumari">Kanyakumari</MenuItem>
                <MenuItem value="Karur">Karur</MenuItem>
                <MenuItem value="Krishnagiri">Krishnagiri</MenuItem>
                <MenuItem value="Madurai">Madurai</MenuItem>
                <MenuItem value="Mayiladuthurai">Mayiladuthurai</MenuItem>
                <MenuItem value="Nagapattinam">Nagapattinam</MenuItem>
                <MenuItem value="Namakkal">Namakkal</MenuItem>
                <MenuItem value="Nilgiris">Nilgiris</MenuItem>
                <MenuItem value="Perambalur">Perambalur</MenuItem>
                <MenuItem value="Pudukkottai">Pudukkottai</MenuItem>
                <MenuItem value="Ramanathapuram">Ramanathapuram</MenuItem>
                <MenuItem value="Ranipet">Ranipet</MenuItem>
                <MenuItem value="Salem">Salem</MenuItem>
                <MenuItem value="Sivaganga">Sivaganga</MenuItem>
                <MenuItem value="Tenkasi">Tenkasi</MenuItem>
                <MenuItem value="Thanjavur">Thanjavur</MenuItem>
                <MenuItem value="Theni">Theni</MenuItem>
                <MenuItem value="Thoothukudi">Thoothukudi</MenuItem>
                <MenuItem value="Thiruchirappalli">Thiruchirappalli</MenuItem>
                <MenuItem value="Tirunelveli">Tirunelveli</MenuItem>
                <MenuItem value="Tirupathi">Tirupathi</MenuItem>
                <MenuItem value="Tiruppur">Tiruppur</MenuItem>
                <MenuItem value="Tiruvallur">Tiruvallur</MenuItem>
                <MenuItem value="Tiruvannamalai">Tiruvannamalai</MenuItem>
                <MenuItem value="Tiruvarur">Tiruvarur</MenuItem>
                <MenuItem value="Vellore">Vellore</MenuItem>
                <MenuItem value="Viluppuram">Viluppuram</MenuItem>
                <MenuItem value="Virudhunagar">Virudhunagar</MenuItem>
                <MenuItem value="Ariyalur">Ariyalur</MenuItem>

              </Select>
            </FormControl>
             </Grid>
            <Grid item xs={6}>
            <FormControl fullWidth margin="dense">
              <InputLabel  shrink
              sx={{
                backgroundColor: "#ffffff",
                px: 1,
                transform: "translate(14px, -6px) scale(0.75)",
               }}
               >State</InputLabel>
              <Select
                value={editedUser?.State || ""}
                onChange={(e) => setEditedUser({ ...editedUser, State: e.target.value })}
              >
                <MenuItem value="Tamil Nadu">Tamil Nadu</MenuItem>
              </Select>
            </FormControl>
             </Grid>
            <Grid item xs={6}>
            <TextField fullWidth type="number" margin="dense" label="Pincode" value={editedUser?.Pincode || ""} 
            onChange={(e) => setEditedUser({...editedUser, Pincode: e.target.value})} />
            </Grid>
            <Grid item xs={6}>
            <TextField fullWidth type="text" margin="dense" label="Member ID" value={editedUser?.Member_ID || ""} 
            onChange={(e) => setEditedUser({...editedUser, Member_ID: e.target.value})} />
            </Grid>
            <Grid item xs={6}>
            <FormControl fullWidth margin="dense">
              <InputLabel  shrink
              sx={{
                backgroundColor: "#ffffff",
                px: 1,
                transform: "translate(14px, -6px) scale(0.75)",
               }}
               >User Type </InputLabel>
              <Select
                value={editedUser?.User_Type || ""}
                onChange={(e) => setEditedUser({ ...editedUser, User_Type: e.target.value })}
              >
                <MenuItem value="superuser">Super User</MenuItem>
                <MenuItem value="admin">Admin</MenuItem>
                <MenuItem value="user">User</MenuItem>
                
              </Select>
            </FormControl>
             </Grid>
            <Grid item xs={6}>
            <TextField fullWidth type="text" margin="dense" label="Occupation" value={editedUser?.Occupation || ""} 
            onChange={(e) => setEditedUser({...editedUser, Occupation: e.target.value})} />
            </Grid>
            <Grid item xs={6}>
            <TextField 
              fullWidth margin="dense" label="Address" value={editedUser?.Address || ""} 
            onChange={(e) => setEditedUser({...editedUser, Address: e.target.value})} />
            </Grid>
            <Grid item xs={6}>
            <TextField fullWidth margin="dense" label="Email ID" value={editedUser?.Email || ""} 
            onChange={(e) => setEditedUser({...editedUser, Email: e.target.value})} />
            </Grid>
            <Grid item xs={6}>
            <TextField fullWidth margin="dense" label="Family Details" value={editedUser?.Family_Details || ""} 
            onChange={(e) => setEditedUser({...editedUser, Family_Details: e.target.value})} />
            </Grid>
            <Grid item xs={6}>
            <FormControl fullWidth margin="dense">
              <InputLabel  shrink
              sx={{
                backgroundColor: "#ffffff",
                px: 1,
                transform: "translate(14px, -6px) scale(0.75)",
               }}
               >Star</InputLabel>
              <Select
                value={editedUser?.Star || ""}
                onChange={(e) => setEditedUser({ ...editedUser, Star: e.target.value })}
              >
                <MenuItem value="Ashwini">Ashwini</MenuItem>
                <MenuItem value="Bharani">Bharani</MenuItem>
                <MenuItem value="Krithikai">Krithikai </MenuItem>
                <MenuItem value="Rohini"> Rohini </MenuItem>
                <MenuItem value="Mirgasheersham">Mirgasheersham</MenuItem>
                <MenuItem value="Thiruvaathirai">Thiruvaathirai</MenuItem>
                <MenuItem value="Punarpoosam">Punarpoosam</MenuItem>
                <MenuItem value="Poosam">Poosam</MenuItem>
                <MenuItem value="Aayilyam">Aayilyam</MenuItem>
                <MenuItem value="Pooram">Pooram</MenuItem>
                <MenuItem value="Uthiram">Uthiram</MenuItem>
                <MenuItem value="Hastham">Hastham</MenuItem>
                <MenuItem value="Chithirai">Chithirai</MenuItem>
                <MenuItem value="Swaathi">Swaathi</MenuItem>
                <MenuItem value="Visaakam">Visaakam</MenuItem>
                <MenuItem value="Anusham">Anusham</MenuItem>
                <MenuItem value="Kettai">Kettai</MenuItem>
                <MenuItem value="Moolam">Moolam</MenuItem>
                <MenuItem value="Pooraadam">Pooraadam</MenuItem>
                <MenuItem value="Uthiraadam">Uthiraadam</MenuItem>
                <MenuItem value="Thiruvonam">Thiruvonam</MenuItem>
                <MenuItem value="Avittam">Avittam</MenuItem>
                <MenuItem value="Chathayam/Sadayam">Chathayam/Sadayam</MenuItem>
                <MenuItem value="Poorattathi">Poorattathi</MenuItem>
                <MenuItem value="Uthirattathi">Uthirattathi</MenuItem>
                <MenuItem value="Revathi">Revathi</MenuItem>
                <MenuItem value="Makam">Makam</MenuItem>
              </Select>
            </FormControl>
             </Grid>
             <Grid item xs={6}>
            <FormControl fullWidth margin="dense">
              <InputLabel  shrink
              sx={{
                backgroundColor: "#ffffff",
                px: 1,
                transform: "translate(14px, -6px) scale(0.75)",
               }}
               >Raasi</InputLabel>
              <Select
                value={editedUser?.Raasi || ""}
                onChange={(e) => setEditedUser({ ...editedUser, Raasi: e.target.value })}
              >
                <MenuItem value="Mesham">Mesham</MenuItem>
                <MenuItem value="Risabham">Risabham</MenuItem>
                <MenuItem value="Mithunam">Mithunam</MenuItem>
                <MenuItem value="Kadagam">Kadagam</MenuItem>
                <MenuItem value="Simmam">Simmam</MenuItem>
                <MenuItem value="Kanni">Kanni</MenuItem>
                <MenuItem value="Thulam">Thulam</MenuItem>
                <MenuItem value="Viruchigam">Viruchigam</MenuItem>
                <MenuItem value="Dhanushu">Dhanushu</MenuItem>
                <MenuItem value="Magaram">Magaram</MenuItem>
                <MenuItem value="Kumbham">Kumbham</MenuItem>
                <MenuItem value="Meenam">Meenam</MenuItem>
              </Select>
            </FormControl>
             </Grid>
            <Grid item xs={6}>
            <TextField fullWidth margin="dense" label="Kootram" value={editedUser?.Kootram || ""} 
            onChange={(e) => setEditedUser({...editedUser, Kootram: e.target.value})} />
            </Grid>
            <Grid item xs={6}>
            <TextField fullWidth margin="dense" label="Kuladeivam" value={editedUser?.Kuladeivam || ""} 
            onChange={(e) => setEditedUser({...editedUser, Kuladeivam: e.target.value})} />
            </Grid>
            <Grid item xs={6}>
            <TextField fullWidth margin="dense" label="Marital Status" value={editedUser?.Marital_Status || ""} 
            onChange={(e) => setEditedUser({...editedUser, Marital_Status: e.target.value})} />
            </Grid>
            <Grid item xs={6}>
            <FormControl fullWidth margin="dense">
                                        <InputLabel  shrink
                                        sx={{
                                          backgroundColor: "#ffffff",
                                          px: 1,
                                          transform: "translate(14px, -6px) scale(0.75)",
                                        }}
                                        >Payment Status</InputLabel>
                                        <Select
                                          value={editedUser?.Payment_Status || ""}
                                          onChange={(e) => handlePaymentStatusChange(e.target.value)}
                                        >
                                          <MenuItem value="Paid">Paid</MenuItem>
                                          <MenuItem value="Unpaid">Unpaid</MenuItem>
                                          
                                          
                                        </Select>
                                      </FormControl>
                                      </Grid>                       
            <Box sx={{ padding: 2, borderRadius: 1, mt: 2 }}>
            <Grid container spacing={3} alignItems="center">
            {/* ID Proof Label & Radio Buttons in One Row */}
            <Grid item xs={12} sm={10}>
              <FormLabel sx={{ whiteSpace: "nowrap" }}>ID Proof</FormLabel>
            </Grid>
            <Grid item xs={10}>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  name="identityProofType"
                  value={editedUser?.ID_Proof_Type || ""}
                  onChange={(e) => setEditedUser({ ...editedUser, ID_Proof_Type: e.target.value })}
                >
              <FormControlLabel value="aadhaar" control={<Radio sx={{ color: "gray" }} />} label="Aadhaar" />
              <FormControlLabel value="license" control={<Radio sx={{ color: "grey" }} />} label="License" />
              <FormControlLabel value="None" control={<Radio sx={{ color: "grey" }} />} label="None" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Aadhaar Number Field */}
        {editedUser?.ID_Proof_Type === "aadhaar" && (
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Aadhaar Number"
              type="text"
              name="identityProofNumber"
              value={editedUser?.ID_Proof_Number || ""}
              onChange={(e) => setEditedUser({ 
                ...editedUser, 
                ID_Proof_Number: e.target.value.replace(/\D/g, "").slice(0, 12) 
              })}
              inputProps={{ maxLength: 12, pattern: "[0-9]{12}" }}
              placeholder="Enter Aadhaar Number"
              required
            />
          </Grid>
        )}

                  {/* License Number Field */}
                  {editedUser?.ID_Proof_Type === "license" && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="License Number"
                        type="text"
                        name="identityProofNumber"
                        value={editedUser?.ID_Proof_Number || ""}
                        onChange={(e) => setEditedUser({ ...editedUser, ID_Proof_Number: e.target.value })}
                        placeholder="Enter License Number"
                        required
                      />
                  
                    </Grid>
                  )}
                </Grid>
                </Box>

                {/* PAN Requirement Selection */}
                <Box sx={{ padding: 2, borderRadius: 1, mt: 2, width: "100%" }}>
                  <Grid container spacing={2} alignItems="center">
                    {/* PAN Number Label */}
                    <Grid item xs={2}>
                    <FormLabel sx={{ whiteSpace: "nowrap" }} >PAN Card</FormLabel>
                    </Grid>

                    {/* PAN Required Radio Buttons */}
                    <Grid item xs={12} sm={10}>
                      <FormControl component="fieldset">
                        <RadioGroup
                          row
                          name="panCard"
                          value={editedUser?.Pan_Card || ""}
                          onChange={(e) => setEditedUser({ ...editedUser, Pan_Card: e.target.value })}
                        >
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />
                          <FormControlLabel value="Later" control={<Radio />} label="Later" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Box sx={{ mt:3}}>
                  {/* PAN Number Field (Only if "Yes" is selected) */}
                  {editedUser?.Pan_Card === "Yes" && (
                    
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          required
                          label="PAN Number"
                          placeholder="Enter PAN Number"
                          name="panCardNumber"
                          value={editedUser?.Pan_Number || ""}
                          onChange={(e) => setEditedUser({ 
                            ...editedUser, 
                            Pan_Number: e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '') 
                          })}
                          inputProps={{ maxLength: 10, pattern: "[A-Z]{5}[0-9]{4}[A-Z]{1}" }}
                        />
                      </Grid>
                  )}
                </Box>
                </Box>

                          </Grid>
          
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">Cancel</Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DataTable;